import ReactDOM, { flushSync } from 'react-dom';
const rootsByContainer = new WeakMap();
const SERVER_REACT18_FLAG_KEY = '__enableReact18';
function isReact18EnabledOnServer() {
    return globalThis[SERVER_REACT18_FLAG_KEY] === true;
}
const RESOLVED_CREATE_ROOT_KEY = '__tsCompatResolvedCreateRoot';
function getCreateRoot() {
    var _a, _b;
    const g = globalThis;
    if (!g[RESOLVED_CREATE_ROOT_KEY]) {
        const createRoot = (_b = (_a = g === null || g === void 0 ? void 0 : g.libs) === null || _a === void 0 ? void 0 : _a.ReactDOMClientLib) === null || _b === void 0 ? void 0 : _b.createRoot;
        if (typeof createRoot === 'function') {
            g[RESOLVED_CREATE_ROOT_KEY] = createRoot;
        }
    }
    return g[RESOLVED_CREATE_ROOT_KEY] || null;
}
function createCompatRoot(container) {
    if (isReact18EnabledOnServer()) {
        const createRoot = getCreateRoot();
        if (createRoot) {
            return createRoot(container);
        }
    }
    return {
        render: node => {
            ReactDOM.render(node, container);
        },
        unmount: () => {
            ReactDOM.unmountComponentAtNode(container);
        },
    };
}
export function renderIntoContainer(node, container, onRendered) {
    let root = rootsByContainer.get(container);
    if (!root) {
        root = createCompatRoot(container);
        rootsByContainer.set(container, root);
    }
    const compatRoot = root;
    if (onRendered) {
        if (isReact18EnabledOnServer()) {
            flushSync(() => compatRoot.render(node));
        }
        else {
            compatRoot.render(node);
        }
        onRendered();
    }
    else {
        compatRoot.render(node);
    }
}
export function unmountContainer(container) {
    const root = rootsByContainer.get(container);
    if (root) {
        root.unmount();
        rootsByContainer.delete(container);
    }
}
//# sourceMappingURL=react-root.util.js.map